module.exports = __webpack_public_path__ + "img/img-eat-07.7eefbc6b.png";